import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M14.727 1.9H9.274c-.818 0-1.468 0-1.993.043-.537.044-.995.136-1.415.35a3.6 3.6 0 0 0-1.573 1.573c-.214.42-.306.877-.35 1.415C3.9 5.806 3.9 6.456 3.9 7.274v9.452c0 .818 0 1.469.043 1.993.044.538.136.996.35 1.415a3.6 3.6 0 0 0 1.573 1.574c.42.213.878.305 1.415.35.525.042 1.175.042 1.993.042H12.5a.6.6 0 1 0 0-1.2H9.3c-.85 0-1.451 0-1.921-.039-.463-.038-.746-.11-.968-.223a2.4 2.4 0 0 1-1.049-1.048c-.113-.223-.185-.505-.223-.968-.038-.47-.039-1.072-.039-1.922V7.3c0-.85 0-1.451.04-1.922.037-.463.109-.745.222-.968a2.4 2.4 0 0 1 1.049-1.048c.222-.114.505-.185.968-.223C7.849 3.1 8.45 3.1 9.3 3.1h5.4c.85 0 1.452 0 1.922.039.463.038.746.11.968.223a2.4 2.4 0 0 1 1.049 1.048c.113.223.185.505.223.968.038.47.038 1.072.038 1.922V11a.6.6 0 1 0 1.2 0V7.274c0-.818 0-1.468-.043-1.993-.043-.538-.135-.996-.349-1.415a3.6 3.6 0 0 0-1.573-1.574c-.42-.213-.878-.305-1.415-.35-.525-.042-1.175-.042-1.993-.042Z"
    />
    <path
      fill="currentColor"
      d="M18.6 15a.6.6 0 0 0-1.2 0v2.4H15a.6.6 0 0 0 0 1.2h2.4V21a.6.6 0 1 0 1.2 0v-2.4H21a.6.6 0 1 0 0-1.2h-2.4V15Z"
    />
  </svg>
`;
